import Vue from 'vue'
import Vuex from 'vuex'
import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './initialState'

Vue.use(Vuex)

/**
 * GETTERS
 */

export const getters = {
  apiUrl: state => {
    return state.apiUrl
  },
  user: state => {
    return state.user
  },
  isSuperAdmin: state => {
    return state.isSuperAdmin
  },
  buckets: state => {
    return state.buckets
  },
  users: state => {
    return state.users
  },
  nodes: state => {
    return state.nodes
  },
  plans: state => {
    return state.plans
  },
  bucketCount: state => {
    return state.bucketCount
  },
  enterpriseBucketCount: state => {
    return state.enterpriseBucketCount
  },
  snackbar: state => {
    return state.snackbar
  },
  isNavigationDrawerOpened: state => {
    return state.isNavigationDrawerOpened
  },
  purchaseOrders: state => {
    return state.purchaseOrders
  },
  bestDownloaders: state => {
    return state.bestDownloaders
  },
  docusignParams: state => {
    return state.docusignParams
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  // Strict mode ensures that state is only mutated through mutation handlers
  // See more http://vuex.vuejs.org/en/strict.html
  strict: process.env.NODE_ENV !== 'production'
  // strict: false
})

export default store
